import { Element } from "@xmpp/xml"
import { type GboxTimelineFeed } from "@/lib/gboxTimeline"

export const NAVIGATOR_TIMELINE_NS = "urn:slickshift:navigator-timeline:0"
export const NAVIGATOR_TIMELINE_COMMAND_NODE = "get_navigator_timeline_view"
export const NAVIGATOR_TIMELINE_PAGE_ELEMENT = "navigator-timeline-page"

const COMMAND_NS = "http://jabber.org/protocol/commands"

export type NavigatorTimelineFeed = GboxTimelineFeed

/**
 * How many Navigator accounts gps could not reach while building the view.
 *
 * gps survives a dead Navigator instance by skipping that account (see
 * navigator_timeline_management.build_view), which makes a successful IQ with
 * no feeds ambiguous: it means either "this fleet has no stops" or "Marcos is
 * down". This count is the only thing that separates the two.
 *
 * An older gps omits the attribute entirely, which reads as no failures.
 */
export const readNavigatorTimelineFailedAccounts = (
  stanza: Element,
): number => {
  const marker = stanza
    .getChild("command", COMMAND_NS)
    ?.getChild(NAVIGATOR_TIMELINE_PAGE_ELEMENT, NAVIGATOR_TIMELINE_NS)
  const parsed = Number.parseInt(marker?.getAttr("failed_accounts") ?? "", 10)
  return Number.isNaN(parsed) || parsed < 0 ? 0 : parsed
}
